<template>
  <div>
    <ChatBoxTitle>
      <div slot="left">
        <img src="../img/back.svg" style="cursor: pointer;" @click="() => { $emit('close') }" alt="Close">
        <!-- <img src="../img/back.svg" @click="$emit('openMenu', false)" alt="back"> -->
      </div>
      <div slot="center">
        Student Profile
        <!-- <a class="title-link" target="_blank" :href="`https://yoteachapp.com/room/${room._id}`" v-if="room && room.title">{{ room.title }}</a> -->
      </div>
      <div slot="right">
      </div>
    </ChatBoxTitle>

    <div class="marginer">
      <h1 class="all-center">
        Welcome to {{ pinuser.person.name }}'s Profile.
      </h1>
      <div class="">

        <p class="all-center">
          <img class="avatar" :src="pinuser.person.avatar" />
        </p>
          <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/TxsSsT3iiqI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
      </div>
      <!-- <h1 class="all-center">
        Feedback
      </h1>
      <div class="all-center">
        <p>Please feel free to leave comments at the feedback room.</p>
      </div>
      <div class="all-center">
        <a href="https://yoteachapp.com/YoTeach_Feedback_v2"><h1>
          Feedback Room
          </h1></a>
      </div> -->
      <!--
      <h2>
        To Begin ...
      </h2>
      <p>
        Click
      </p> -->
    </div>

    <TabBar @bar="(v) => { $emit('bar', v) }"></TabBar>
  </div>
</template>

<script>
import TabBar from './TabBar.vue'
import ChatBoxTitle from './ChatBoxTitle.vue'
import { API } from '@/yoteach2-gui/parts/index.js'

export default {
  API,
  props: {
    pinuser: {}
  },
  components: {
    TabBar,
    ChatBoxTitle
  }
}
</script>

<style scoped>
.all-center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar{
  max-width: 250px;
  max-height: 250px;
}
</style>
